module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/2/3-56d0f1beec9f4b6872facf935327f861.jpg";